import { add } from 'date-fns';
import React from 'react';
import { useController, useFormContext, useWatch } from 'react-hook-form';

import CustomFormControl from './custom-form-control';
import DatePickerInput from './date-picker-input';
import { FormContext } from './form';
import { styles } from './styles';

interface AfterTodayDatePickerProps {
  name: string;
  label?: string;
  placeholder?: string;
  onAfterChange?: (date: Date | null) => void;
  disabled?: boolean;
  required?: boolean;
}

export default function AfterTodayDatePicker(props: AfterTodayDatePickerProps) {
  const {
    name,
    label,
    placeholder = 'DD/MM/YYYY',
    onAfterChange,
    required = true,
    ...restProps
  } = props;

  const { fieldState } = useController({ name: props.name });

  const context = React.useContext(FormContext);
  const { control, setValue, clearErrors } = useFormContext();
  const value = useWatch({ control, name });

  const tomorrowDate = add(new Date(), { days: 1 });

  const disabled = !context.editable || restProps.disabled;

  return (
    <CustomFormControl
      required={required}
      label={label}
      error={fieldState.error?.message}
      disabled={disabled}
    >
      <DatePickerInput
        {...restProps}
        type="default"
        name={name}
        size="xs"
        defaultDate={tomorrowDate}
        minDate={tomorrowDate}
        placeholder={placeholder}
        value={value}
        onChange={(value) => {
          setValue(name, (value as Date) ?? null);
          clearErrors();
          onAfterChange?.(value as Date);
        }}
        clearable
        disabled={disabled}
        required
        styles={{
          root: {
            marginBottom: '16px',
          },
          wrapper: {
            ...(disabled ? styles.reset : {}),
          },
          input: {
            fontSize: '16px',
            ...(disabled ? styles.reset : {}),
          },
        }}
      />
    </CustomFormControl>
  );
}
